/* eslint no-use-before-define: 0 */
import React from "react";
import { useFormik, FormikProvider, Field } from "formik";
import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import styles from "./autoComplete.module.scss";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import i18next from "i18next";
import _ from "lodash";
import PropTypes from "prop-types";

function AutoComplete(props) {
  const {
    label,
    name,
    options,
    placeholder,
    isSelect = true,
    loading = false,
    noOptionsText = i18next.t("No results found"),
    hasSubText = false,
    subTextField = { title: "", id: null, subText: [] },
    hasError = false,
    hasShowKeyValuePair = false,
    ...rest
  } = props;

  const getOptionSection = (option) => {
    if (hasSubText) {
      return (
        <Box className={styles.optionWrapper}>
          <Box className={styles.optionHeader}>
            {_.isNull(option[subTextField.id]) ||
            _.isUndefined(option[subTextField.id])
              ? option[subTextField.title]
              : `${option[subTextField.id]} : ${option[subTextField.title]}`}
          </Box>
          {_.isEmpty(subTextField?.subText) ? null : (
            <Box className={styles.optionSubHeader}>
              {subTextField?.subText.reduce((currentText, field) => {
                let extn = _.isEmpty(currentText) ? "" : ",";
                let textItem = !_.isEmpty(option[field]) ? option[field] : "-";
                return currentText + extn + textItem;
              }, "")}
            </Box>
          )}
        </Box>
      );
    } else {
      return i18next.t(option?.key);
    }
  };

  const formik = useFormik({
    validateOnChange: ({ values }) => (formik.values = values),
  });
  return (
    <Box
      className={
        hasError
          ? `${styles.autocompleteWrapper} ${styles.inputError}`
          : styles.autocompleteWrapper
      }
      data-testid="AutoComplete"
    >
      <FormikProvider value={formik}>
        <Field
          as="select"
          id={name}
          name={name}
          className={`${styles.selectSection}`}
        >
          {({ field, form }) => (
            <FormControl error className={styles.formFieldWrapper}>
              <Autocomplete
                {...rest}
                popupIcon={<KeyboardArrowDownOutlinedIcon />}
                options={options}
                noOptionsText={noOptionsText}
                // value={field.value}
                label={label}
                error={Boolean(form.touched[name] && form.errors[name])}
                isOptionEqualToValue={(option, value) =>
                  option.value === value?.value
                }
                loading={loading}
                getOptionLabel={(option) =>
                  hasShowKeyValuePair && !_.isEmpty(option)
                    ? `${option.value} : ${option.key}`
                    : i18next.t(option?.key)
                }
                disableClearable={true}
                renderOption={(props, option, { selected }) => {
                  return (
                    <li
                      {...props}
                      className={
                        hasSubText
                          ? "MuiAutocomplete-option withSubtextOption"
                          : "MuiAutocomplete-option withoutSubtextOption"
                      }
                    >
                      {getOptionSection(option)}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    hiddenLabel
                    className={`input-grp__box inputSelectStyle ${
                      !isSelect ? "autocompletInput" : ""
                    }`}
                    type="text"
                    placeholder={placeholder}
                    size="small"
                    variant="filled"
                    disabled={false}
                    {...params}
                  />
                )}
                disabled={props.dropDownEnabled}
              />
            </FormControl>
          )}
        </Field>
      </FormikProvider>
    </Box>
  );
}

export default AutoComplete;
AutoComplete.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.any,
  placeholder: PropTypes.string,
  isSelect: PropTypes.bool,
  loading: PropTypes.bool,
  noOptionsText: PropTypes.string,
  hasSubText: PropTypes.bool,
  subTextField: PropTypes.any,
  hasError: PropTypes.bool,
  dropDownEnabled: PropTypes.bool,
  hasShowKeyValuePair: PropTypes.bool,
};
